import { Skeleton } from "@/components/ui/skeleton"

export function InvitesSkeleton() {
  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-6 rounded-full" />
          <Skeleton className="h-9 w-48" />
        </div>
        <Skeleton className="h-5 w-64 mt-2" />
      </div>

      <div className="grid gap-4">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton structure
            key={`skeleton-invite-${i}`}
            className="rounded-xl border shadow-sm"
          >
            <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between p-6">
              <div className="space-y-2">
                <Skeleton className="h-6 w-48" />
                <Skeleton className="h-4 w-32" />
              </div>
              <Skeleton className="h-5 w-32" />
            </div>
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between p-6 pt-0">
              <Skeleton className="h-5 w-48" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-10 w-32" />
                <Skeleton className="h-10 w-24" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
